const ALIAS = 'api';

export function getCustomDeliveryTime(zone) {
    return axios.get(`${ALIAS}/getCustomDeliveryTime`, {params: {zone: zone}});
}

export function getCustomCookingTime(shop) {
    return axios.get(`${ALIAS}/getCustomCookingTime`, {params: {shop: shop}});
}
